export enum VoiceContactStatusAgent {
  RINGING = 'Ringing',
  INCOMING = 'Incoming',
  ACTIVE = 'Active',
  DISCONNECTED = 'Disconnected',
  HOLD = 'Hold',
  HOLDING = 'Holding',
  JOINED = 'Joined',
  DIALING = 'Dialing',
  MASKING = 'Masking',
  INQUEUE = 'Inqueue',
  TRANSFER = 'Transfer',
  CONFERENCE = 'Conference',
  PREVIEW = 'Preview',
  CALLBACK = 'Callback',
  CALL_BACK_DISCONNECTED = 'Callbackdisconnected',
  NATURAL_CALL_DIALING = 'Naturalcalldialing',
  NATURAL_CALL_AMD = 'Naturalcallamd',
  NATURAL_CALL_RINGING = 'Naturalcallringing',
}
